<!-- User is an admin, no campaigns exist-->
<ng-container *appIfInRole="['administrator']">
  <div class="content center">

    <div class="empty flex flexJustify--center flexAlign--center">

      <!--  Assessment sare still defaults-->
      <ng-container *ngIf="(areAssessmentsDefault$ | async)">
        <img class="empty__img" src="/assets/icons/illustrations/empty-rocket.svg">
        <h2 class="col__ align--center empty__heading">Let's get this organization off the ground!</h2>
        <p class="empty__deck align--center">Before creating any campaigns, you will need to set up your assessment
          levels.</p>
        <div class="col__ flex flexJustify--center">
          <a class="btn btn--lg btn--red vert-0200" routerLink="/admin/assessment/manage">
            <i class="fal fa-fw fa-sliders spacerRight"></i>Set Up Assessments
          </a>
        </div>
      </ng-container>

      <ng-container *ngIf="(areAssessmentsDefault$ | async) === false">
          <img class="empty__img" src="/assets/icons/illustrations/empty-rocket.svg">
          <h2 class="col__ align--center empty__heading">Let's get this organization off the ground!</h2>
          <p class="empty__deck align--center">Create your first campaign</p>
          <div class="col__ flex flexJustify--center">
              <span class="btn btn--lg btn--red vert-0200" (click)="openCreateCampaignDialog()">
                  <i class="fal fa-fw fa-sitemap spacerRight"></i>Create A Campaign</span>
          </div>
        </ng-container>

    </div>
  </div>
</ng-container>


<!-- User is a lead with no campaigns assigned-->
<ng-container *appIfInRole="['lead']">
  <div class="content center">

    <div class="empty flex flexJustify--center flexAlign--center">

      <img class="empty__img" src="/assets/icons/illustrations/empty-rocket.svg">
      <h2 class="col__ align--center empty__heading">You don't have access to any campaigns, get started by creating a
        campaign.</h2>
      <p class="empty__deck align--center">If you need access to an existing campaign contact your administrator.</p>
      <div class="col__ flex flexJustify--center">
        <span class="btn btn--lg btn--red vert-0200" (click)="openCreateCampaignDialog()">
          <i class="fal fa-fw fa-sitemap spacerRight"></i>Create A Campaign</span>
      </div>
    </div>
  </div>
</ng-container>

<!-- User is an organizer / activist with no campaigns assigned-->
<ng-container *appIfInRole="['organizer', 'activist']">
  <div class="content content--narrow vert-0500 center">

    <h1 class="h2">
      You do not have access to any campaigns.
    </h1>

    <p class="large vert-0100">
      Please contact an Administrator if you need access to a campaign.
    </p>
    <p>
      <span class="link" (click)="onClickSignOut()">Click here to sign out.</span>
    </p>
  </div>
</ng-container>
